import { BAR, FUNNEL, HORIZONTAL_STACKED, LINE, PIE, PIE_GRADE, RADAR, VERTICAL_STACKED } from "src/components/Charts/types";

/**
 * Aqui está o core da visualização do preview do gráfico, abaixo estão definidas quais os dados de séries
 * que serão renderizados dependendo do gráfico atualmente selecionado.
 */
function getBarSeries(firstColor, secondColor) {
  return [
    {
      name: 'LEGENDA',
      type: 'bar',
      data: [55],
      itemStyle: {
        color: secondColor,
      },
    },
    {
      name: 'LEGENDA ',
      type: 'bar',
      data: [45],
      itemStyle: {
        color: firstColor,
      },
    },
  ];
}

function getPieSeries(showPercentage = false, firstColor, secondColor) {
  return [
    {
      startAngle: 324,
      radius: ['58%', '70%'],
      type: 'pie',
      label: {
        show: showPercentage,
      },
      labelLine: {
        show: showPercentage,
        length: 26.87,
        length2: 40,
      },
      data: [
        { value: 65,
          name: 'LEGENDA',
          itemStyle: {
            color: secondColor,
          },
        },
        { value: 35,
          name: 'LEGENDA ',
          itemStyle: {
            color: firstColor,
          },
        },
      ],
    },
  ]
}

function getFunnelSeries(showPercentage = false, firstColor, secondColor) {
  return [
    {
      label: {
        position: 'inside',
        show: showPercentage,
      },
      name: 'Funnel',
      type: 'funnel',
      data: [
        { value: 25,
          name: 'LEGENDA',
          itemStyle: {
            color: firstColor,
          },
        },
        { value: 75,
          name: 'LEGENDA ',
          itemStyle: {
            color: secondColor,
          },
        },
      ],
    },
  ]
}

function getLineSeries(firstColor, secondColor) {
  return [
    {
      name: 'LEGENDA',
      type: 'line',
      data: [50.01, 50.0],
      itemStyle: {
        color: firstColor,
      },
    },
    {
      name: 'LEGENDA ',
      type: 'line',
      data: [20, 20],
      itemStyle: {
        color: secondColor,
      },
    },
  ]
}

function getRadarSeries(firstColor, secondColor) {
  return [
    {
      type: 'bar',
      data: [1, 2],
      coordinateSystem: 'polar',
      name: 'LEGENDA',
      stack: 'a',
      emphasis: {
        focus: 'series'
      },
      itemStyle: {
        color: secondColor,
      },
    },
    {
      type: 'bar',
      data: [2, 4],
      coordinateSystem: 'polar',
      name: 'LEGENDA ',
      stack: 'a',
      emphasis: {
        focus: 'series'
      },
      itemStyle: {
        color: firstColor,
      },
    },
  ]
}

const seriesByChartType = {
  [BAR]: getBarSeries,
  [HORIZONTAL_STACKED]: getBarSeries,
  [VERTICAL_STACKED]: getBarSeries,
  [PIE]: getPieSeries,
  [PIE_GRADE]: getPieSeries,
  [FUNNEL]: getFunnelSeries,
  [LINE]: getLineSeries,
  [RADAR]: getRadarSeries,
};

/**
 * 
 * @param {string} chartType - Tipo do gráfico {BAR|TypeN}
 * @param {boolean} showPercentages - Boolean que indica se porcentagens devem ser apresentadas no componente de preview
 * @param {string} themeTitle - Título do tema da aplicação { DARK | LIGHT }
 * @returns Objeto de series do componente de preview do gráfico.
 */
export function getSerieConfig(chartType, showPercentages = true, themeTitle) {
  const firstItemColor = themeTitle === 'dark' ? '#FF61B6' : '#E5209D';
  const secondItemColor = themeTitle === 'dark' ? '#00BEC1' : '#002878';

  if ([BAR, LINE, RADAR, HORIZONTAL_STACKED, VERTICAL_STACKED].includes(chartType)) {
    return seriesByChartType[chartType](firstItemColor, secondItemColor);
  }
  return seriesByChartType[chartType](showPercentages, firstItemColor, secondItemColor);
}